import React, { useState } from 'react';

import { apiUrl } from '../utils/apiBase';
import type { RotationState } from './scoring-types';

interface Props {
  token: string;
  rotation: RotationState;
  onDealt: () => void;
}

function progressLabel(rotation: RotationState): string {
  if (rotation.dealtRuns === 0) {
    return `${rotation.formatTitle} — kolejka czeka na pierwszą rundę.`;
  }

  return `${rotation.formatTitle} · rozegrane rundy: ${rotation.dealtRuns}`;
}

export const RotationNextRun: React.FC<Props> = ({ token, rotation, onDealt }) => {
  const [dealing, setDealing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleDeal(): Promise<void> {
    setError(null);
    setDealing(true);

    try {
      const response = await fetch(apiUrl(`/api/public/scoring/${token}/runs`), { method: 'POST' });

      if (!response.ok) {
        const body = (await response.json().catch(() => null)) as { error?: string } | null;
        setError(body?.error ?? `Błąd serwera (${response.status})`);

        return;
      }

      onDealt();
    } catch {
      setError('Błąd połączenia z serwerem.');
    } finally {
      setDealing(false);
    }
  }

  return (
    <section className="rotation-next-run" data-testid="rotation-next-run">
      <p className="rotation-next-run__meta">{progressLabel(rotation)}</p>

      {rotation.canDealNextRun ? (
        <button
          type="button"
          className="btn btn-primary rotation-next-run__btn"
          data-testid="rotation-deal-run"
          onClick={() => void handleDeal()}
          disabled={dealing}
        >
          {dealing ? 'Losowanie…' : `Rozpocznij rundę ${rotation.nextRunNumber}`}
        </button>
      ) : (
        <p className="rotation-next-run__blocked" data-testid="rotation-blocked">
          {rotation.blockedReason}
        </p>
      )}

      {error && (
        <p className="rotation-next-run__error" role="alert" data-testid="rotation-error">
          {error}
        </p>
      )}
    </section>
  );
};

export default RotationNextRun;
